import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

const TableSectionHeader = React.memo(({ title, onDownload, disabled }) => (
  <div className="table-section-header">
    <h2 className="table-section-title">{title}</h2>
    <button
      type="button"
      className="insights-download-button"
      onClick={onDownload}
      disabled={disabled}
      title="Download spreadsheet snapshot"
    >
      <FontAwesomeIcon icon={faDownload} /> Download
    </button>
  </div>
));

export default TableSectionHeader;
